import {
  FlexColumn,
  isUserWithRoles,
  useCombinedUser,
  useIsMsalAuth,
  useIsUserAuth,
  UserRoles,
} from '@equifinance/shared';
import styled from 'styled-components';
import { useMemo } from 'react';
import { DocumentaryEvidence } from './DocumentaryEvidence';
import { WrittenEvidence } from './WrittenEvidence';
import { Task, useTasksContext } from '../../../../contexts/tasks';
import { filesToTaskDocuments } from '../../common/taskDocument';
import UploadDocuments from '../../../UploadDocuments';

const EvidenceContainer = styled(FlexColumn)`${({ theme }) => `
  padding: ${theme.padding[3]} ${theme.padding[5]};
  gap: ${theme.padding[7]};
`}`;

export function Evidence({ task, taskIndex }: { task: Task, taskIndex: number }) {
  const { uploadTaskDocuments } = useTasksContext();

  const isInternalUser = useIsMsalAuth();
  const { user } = useCombinedUser();
  const isUnderwriter = isInternalUser && isUserWithRoles([UserRoles.UNDERWRITER], user);
  const isSalesSupport = isInternalUser && isUserWithRoles([UserRoles.SALES_SUPPORT], user);
  const isExternalUser = useIsUserAuth();

  const isAllowedUpload = useMemo(
    () => (
      ((isUnderwriter) && task.status !== 'Draft')
      || ((isExternalUser || isSalesSupport) && ['OutstandingForBroker', 'Rejected', 'MoreInformationRequired'].includes(task.status))),
    [task.status, isUnderwriter, isSalesSupport, isExternalUser],
  );

  const canUpload = task.canUpload ?? isAllowedUpload;

  const uploadingFiles = async (files: File[]) => {
    const documents = await filesToTaskDocuments(files, task.id);
    await uploadTaskDocuments({ documents });
  };

  return (
    <EvidenceContainer>
      <DocumentaryEvidence documents={task.documentEvidence ?? []} taskIndex={taskIndex} />
      <UploadDocuments
        disabled={!canUpload}
        uploadingFiles={uploadingFiles}
      />
      <WrittenEvidence task={task} />
    </EvidenceContainer>
  );
}
